import styled, { css } from 'styled-components';
import { getGridSpan, getGridSpans, getSpace, getTextType, mq } from '../../../stylesheets/tools';

const StyledEventInfo = styled.div`
  ${mq('m')} {
    display: flex;
  }

  .event__date {
    margin: ${getSpace('l')} ${getGridSpan(1)} 0 30px;
    z-index: 1;

    ${mq('m')} {
      margin: ${getSpace('l')} 0 0;
    }

    ${props =>
      !props.$period &&
      css`
        ${mq('m')} {
          margin-left: ${getGridSpan(1, 'spread')};
          margin-right: 30px;
        }
      `}
  }

  .event__content-wrapper {
    ${getGridSpans('width', { s: 12, m: 8, l: 7 })}
  }

  .event__content {
    position: relative;
    background: ${props => props.theme.siteTheme.primary};
    border-radius: 10px;
    padding: 90px 30px 30px;
    margin-top: -50px;

    ${mq('m')} {
      right: ${getGridSpan(1, 'spread')};
      margin-top: 0;
      padding: 105px ${getGridSpan(1)} 60px 11%;
      ${props =>
        !props.$period &&
        css`
          padding: 105px 80px 60px;
        `}

      ${props =>
        !props.$gomusDates &&
        css`
          right: auto;
          left: ${getGridSpan(3, 'spread')};
          margin-top: 0;
          padding: 60px 11% 60px 11%;
        `}
    }
  }

  .event__booking {
    position: relative;
    text-align: right;
    margin-top: ${getSpace('xs')};

    ${mq('m')} {
      right: ${getGridSpan(1, 'spread')};
    }
  }

  .event__location {
    ${getTextType('secondary')}
    text-transform: uppercase;
    hyphens: auto;
  }

  .event__time {
    ${getTextType('subline')}
    text-transform: uppercase;
    margin-bottom: ${getSpace('xs')};
  }

  .event__price {
    margin: 0 0 ${getSpace('m')};
  }

  .event__copy {
    margin: ${getSpace('m')} 0;
  }

  .event__meta-headline {
    margin-bottom: 0;
  }

  .event__meta {
    margin: ${getSpace('l')} 0 0;
  }

  .event__meta-list {
    margin: 0 0 ${getSpace('xxs')};
    padding: 0;
    list-style-type: none;

    li {
      margin: ${getSpace('5px')} 0;

      p {
        display: inline-block;
        margin: 0;
      }
    }
  }

  .event__meta-name {
    padding-right: ${getSpace('8px')};
  }

  .event__price-list {
    list-style-type: none;
    margin: ${getSpace('m')} 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      margin: ${getSpace('xs')} 0;

      .event__price-name {
        flex-grow: 2;
        margin-right: 15px;
      }

      .event__price-value {
        min-width: 23px;
      }
    }
  }
`;

export default StyledEventInfo;
